import { timeMixin } from './time';
import { appMixin } from './app';

export const mixins = {
	mixins: [ timeMixin, appMixin ]
};